import { usePagination } from "@/shared/navigation/pagination";
import { useQuery } from "@apollo/client";
import { GET_PERSON_NOTIFICATIONS } from "@/modules/common/widgets/notification-bell/api/get-person-notifications";
import { useRef } from "react";

export function useNotifications() {
  const { pageRequest } = usePagination();
  const { data, loading, fetchMore } = useQuery(GET_PERSON_NOTIFICATIONS, {
    variables: {
      pagination: pageRequest,
      filter: {
        read: false,
      },
    },
  });

  const notifications = data?.getPersonNotifications.content ?? [];
  const nextPage = useRef(pageRequest.page + 1);

  const loadMore = async () => {
    await fetchMore({
      variables: {
        pagination: {
          ...pageRequest,
          page: nextPage.current,
        },
        filter: {
          read: false,
        },
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        nextPage.current = nextPage.current + 1;

        const loadedNotifications = [
          ...previousResult.getPersonNotifications.content,
          ...fetchMoreResult.getPersonNotifications.content,
        ];

        const idsInResult: Record<string, boolean> = {};

        const uniqueNotifications = loadedNotifications.filter(
          (notification) => {
            if (idsInResult[notification.id]) {
              return false;
            }

            idsInResult[notification.id] = true;
            return true;
          },
        );

        return {
          ...previousResult,
          getPersonNotifications: {
            ...fetchMoreResult.getPersonNotifications,
            content: uniqueNotifications,
          },
        };
      },
    });
  };

  return {
    notifications,
    loading,
    loadMore,
    total: data?.getPersonNotifications.total ?? 0,
  };
}
